import styled from "styled-components";

const ErrorWrapper = styled.div`
  display: flex;
  color: red;
  align-items: center;
  justify-content: center;
`;

const WarningWrapper = styled.div`
  display: flex;
  color: orange;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  white-space: nowrap;

  .product-select {
    .ant-select {
      min-width: 180px;
    }
  }
`;

const ProductHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  min-height: 30px;

  .ant-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 19px;
    width: 19px;
    height: 26px;

    &.ant-btn-circle {
      border-radius: 50%;
    }

    &:hover {
      background-color: white;
    }
  }

  .ant-select {
    width: 100px;
  }
`;

const RowHeading = styled.div`
  width: 85px;
  min-width: 85px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 5px;
  min-height: 27px;
  padding-right: 5px;

  &:last-of-type {
    min-height: 27px;
    margin-bottom: 20px;
  }

  &.overallTemplateLabel {
    line-height: 1.2;
    text-align: end;
    padding-top: 0px;
  }
`;

const ProductColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 142px;
  min-width: 142px;
  justify-content: flex-start;

  &:first-child {
    min-width: 85px;
    width: 85px;
    position: sticky;
    left: 0;
    z-index: 10;
    background: white;
    padding-top: 28px;

    div {
      background: white;
    }
  }
`;

const SwitchToProductModeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 15px;

  .ant-btn {
    display: flex;
    align-items: center;
  }
`;

const NewProductWrapper = styled.div`
  .ant-btn {
    width: 142px;
    min-width: 142px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const TableContainer = styled.div`
  font-size: 1.3rem;
  display: flex;
  flex-direction: column;
  height: calc(100% - 60px); // subtracting height of template selector

  .ant-btn {
    max-height: 26px;
  }

  .ant-select {
    height: 26px;
    font-size: 1.3rem;

    .ant-select-selection-search {
      display: flex;
    }

    .ant-select-selection-item {
      display: flex;
      align-items: center;
    }

    .ant-select-selector {
      height: 26px;
    }
  }

  .ant-input {
    padding: 0 3px;
    font-size: 1.3rem;
    height: 27px;
  }

  .ant-picker {
    padding: 0 5px;
  }

  .ant-picker-input > input {
    font-size: 1.3rem;
    height: 25px;
  }

  .sticky-col {
    position: sticky;
    background-color: white;
  }
`;

const TemplateSelectorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  padding: 15px 0 10px;

  .overall-template-select {
    max-width: 342px;
    width: calc(60% - 50px); // subtracting half of the label column width + 5px gap
  }

  .rescat-select {
    max-width: 110px;
    width: calc(40% - 50px); // subtracting half of the label column width + 5px gap
  }
`;

const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ProductColumnContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  overflow: auto;
  height: 100%;
  padding-right: 20px;
`;

const RootContainer = styled.div`
  max-width: 100%;
  height: 100%;
`;
const FlexRightContainer = styled.div`
  margin-left: auto;
  display: flex;
  position: absolute;
  right: 0;
`;

export {
  ErrorWrapper,
  WarningWrapper,
  Wrapper,
  ProductHeaderContainer,
  RowHeading,
  ProductColumnWrapper,
  SwitchToProductModeWrapper,
  NewProductWrapper,
  TableContainer,
  TemplateSelectorWrapper,
  ColumnContainer,
  ProductColumnContainer,
  RootContainer,
  FlexRightContainer
};
